/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szme037aResponseCdtmnyDetailInfDto { 
    /**
     * 内訳表示用名称：全半角混在
     */
    detailHyojiAname: string;
    /**
     * 料金コード金額：数字
     */
    chargeCodeMny: number;
}

